export const getStorage = () => {
  // Check if the user exists in sessionStorage
  if (sessionStorage.getItem('userData')) {
    return sessionStorage;
  }

  // If user is not found in sessionStorage, check localStorage
  if (localStorage.getItem('userData')) {
    return localStorage;
  }

  // If user is not found in either storage, return null or handle it as needed
  return null;
};


export const getUserFromStorage = () => {
  const storage = getStorage();
  const userData = storage && storage.getItem('userData');
  return JSON.parse(userData);
};


export const saveUserToStorage = (userData, rememberMe) => {
  // Determine the storage based on the "remember me" variable
  const storage = rememberMe ? localStorage : sessionStorage;

  // Convert the user data to a string and save it to the storage
  storage && storage.setItem('userData', JSON.stringify(userData));
};


export const getIsVerifiedFromStorage = () => {
  const storage = getStorage();
  const isVerified = storage && storage.getItem('is_verified');
  return JSON.parse(isVerified);
};


export const saveIsVerifiedToStorage = (is_verified) => {
  const storage = getStorage();
  storage && storage.setItem('is_verified', JSON.stringify(is_verified));
};


export const removeUserFromStorage = () => {
  // Remove user data from sessionStorage
  sessionStorage.removeItem('userData');
  sessionStorage.removeItem('is_verified');
  sessionStorage.removeItem('lastResendTimestamp');

  // Remove user data from localStorage
  localStorage.removeItem('userData');
  localStorage.removeItem('is_verified');
  localStorage.removeItem('lastResendTimestamp');
};
